import type { AccountType, SessionUser } from '@/types/auth'

export const permissions = {
  dashboardView: 'dashboard:view',
  companyView: 'company:view',
  companyEdit: 'company:edit',
  merchantView: 'merchant:view',
  merchantEdit: 'merchant:edit',
  goodsView: 'goods:view',
  giftCategoryView: 'category:gift:view',
  starCategoryView: 'category:star:view',
  tagCategoryView: 'category:tag:view',
  ordersView: 'orders:view',
  membersView: 'members:view',
  membersEdit: 'members:edit',
  financeView: 'finance:view',
  financeAudit: 'finance:audit',
  liveView: 'live:view',
  contentView: 'content:view',
  advertisingView: 'advertising:view',
  versionView: 'version:view',
  settingsView: 'settings:view',
  subAccountView: 'sub-account:view',
  parameterConfigView: 'parameter-config:view',
} as const

const common = [
  permissions.dashboardView,
  permissions.merchantView,
  permissions.merchantEdit,
  permissions.ordersView,
  permissions.membersView,
  permissions.parameterConfigView,
]

export function accountTypeFor(name: string): AccountType {
  if (name === 'yoomiito' || name === 'ymmt-dev') return 'admin'
  if (name === '18926767100') return 'finance'
  if (name === 'guimihui' || name === 'haoweisheng') return 'partner'
  return 'company'
}

export function permissionsFor(user: Pick<SessionUser, 'name' | 'companyId'>): string[] {
  const accountType = accountTypeFor(user.name)
  const isHeadOffice = Boolean(user.companyId && user.companyId > 0 && user.companyId <= 3)
  const result = new Set<string>(common)

  if (accountType === 'admin' || accountType === 'partner' || accountType === 'finance') {
    result.add(permissions.membersEdit)
  }
  if (accountType === 'finance') result.add(permissions.financeAudit)

  if (isHeadOffice || accountType === 'admin' || accountType === 'finance') {
    result.add(permissions.companyView)
    result.add(permissions.companyEdit)
    result.add(permissions.goodsView)
    result.add(permissions.giftCategoryView)
    result.add(permissions.starCategoryView)
    result.add(permissions.tagCategoryView)
    result.add(permissions.financeView)
    result.add(permissions.liveView)
    result.add(permissions.contentView)
    result.add(permissions.versionView)
  } else {
    result.add(permissions.goodsView)
  }

  if (accountType === 'company' || result.has(permissions.contentView)) {
    result.add(permissions.advertisingView)
    result.add(permissions.versionView)
  }

  if (accountType === 'company' || accountType === 'admin') {
    result.add(permissions.subAccountView)
  }
  if (accountType === 'admin') result.add(permissions.settingsView)
  return [...result]
}
